"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InnereRuheFinden() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="innere-ruhe-finden" className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background !bg-[url(https://proper-salmon-1.10web.cloud/wp-content/uploads/2026/04/provence_retreat_landscape_highres.png)] bg-cover bg-center bg-no-repeat">
      {}
      <div className="absolute inset-0 z-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/swiss_lavender_field_dusk.png)] bg-cover bg-center bg-no-repeat" aria-hidden="true" />
      
      {}
      <div className="absolute inset-0 z-0 bg-black/10" aria-hidden="true" />

      {}
      <div ref={ref} className={`relative z-10 mx-auto max-w-4xl px-6 text-center md:px-12 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <h1 className="font-serif text-5xl font-medium tracking-tight text-white drop-shadow-md md:text-7xl lg:text-8xl">
          Finde deine innere Klarheit
        </h1>
        
        <p className="mx-auto mt-6 max-w-2xl font-sans text-lg font-light text-white/90 drop-shadow-sm md:mt-8 md:text-xl lg:text-2xl">Ein Ort für emotionale Klarheit und ganzheitliche Heilung.</p>
        
        <div className="mt-10 md:mt-12">
          <Button asChild size="lg" className="h-14 rounded-sm bg-white px-8 text-base text-primary shadow-lg hover:bg-white/90">
            <Link to="/AngebotePage">
              Begleitung entdecken
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}